import {
  InvoiceResponse,
  ListDocumentsResponse,
  TransformInvoiceResponse,
} from './invoices.types'

export const transformListInvoices = (
  response: InvoiceResponse[],
  customerId: string
): TransformInvoiceResponse[] => {
  const filteredResponse = customerId
    ? response.filter((item) => item.customerId === customerId)
    : response

  const map = new Map<string, InvoiceResponse[]>()

  for (const item of filteredResponse) {
    if (!map.has(item.customerName)) {
      map.set(item.customerName, [])
    }
    map.get(item.customerName)!.push(item)
  }

  return Array.from(map, ([customerName, invoiceData]) => ({
    customerName,
    invoiceData,
  }))
}

// export const transformListInvoiceDocuments = (
//   documents: ListDocumentsResponse
// ): TransformedDocument[] => {
//   return Object.entries(documents).flatMap(([documentType, files]) =>
//     files.map((file: File) => ({
//       documentType,
//       ...file,
//     }))
//   )
// }

export const transformListInvoiceDocuments = (
  documents: ListDocumentsResponse
): ListDocumentsResponse => {
  const documentTypes: string[] = [
    'INVOICE',
    'WAYBILL',
    'LC',
    'BOL',
    'POD',
    // 'REMITTANCE',
    // 'RECEIPT',
  ]

  return documentTypes.reduce((acc, type) => {
    acc[type] = documents[type] ?? []
    return acc
  }, {} as ListDocumentsResponse)
}
